import { gql } from '@apollo/client';

export const GET_PROFILE = gql`
  query getAdminUser {
    getAdminUser {
      id
      firstName
      lastName
      email
      imageUrl
      phone
      role {
        name
        permissions {
          id
          name
        }
      }
    }
  }
`;

export const GET_ALL_TRANSACTIONS = gql`
  query getAllTransactionsAdminCa(
    $limit: Int
    $offset: Int
    $search: String
    $filters: FiltersType
    $statusFilter: String
    $userId: String
  ) {
    getAllTransactionsAdminCa(
      limit: $limit
      offset: $offset
      search: $search
      filters: $filters
      statusFilter: $statusFilter
      userId: $userId
    ) {
      count
      transactions {
        id
        status
        narration
        narration
        description
        amount
        createdAt
        txRef
        paymentMethod
        fees
        message
        user {
          imageUrl
          firstName
          lastName
          email
        }
        loan {
          id
          loanSchedules {
            dueDate
            amountDue
          }
        }
      }
    }
  }
`;

export const GET_BILLS_PAYMENT = gql`
  query GetBillPaymentsAdminCa(
    $limit: Int
    $offset: Int
    $filter: BillPaymentFilter
  ) {
    getBillPaymentsAdminCa(limit: $limit, offset: $offset, filter: $filter) {
      all
      success
      pending
      failed
      billPayments {
        count
        data {
          id
          userId
          biller
          billerCode
          accountId
          currency
          amount
          fee
          status
          narration
          datePaid
          meta
          createdAt
          updatedAt
          user {
            firstName
            lastName
            email
          }
        }
      }
    }
  }
`;

export const GET_ALL_REWARDS = gql`
  query GetTopReferrals(
    $limit: Int
    $offset: Int
    $filters: DateFilter
    $search: String
  ) {
    getTopReferrals(
      limit: $limit
      offset: $offset
      filters: $filters
      search: $search
    ) {
      count
      referrals {
        id
        userId
        referralCode
        earnings
        totalReferred
        completedReferrals
        createdAt
        updatedAt
        user {
          firstName
          lastName
          email
          imageUrl
          primaryAddress {
            location
          }
          userRtDetail {
            enrollment_type
            onboardingStatus
          }
          status
        }
      }
    }
  }
`;

export const GET_PROPERTY_AGENTS = gql`
  query GetPropertyAgents(
    $from: String
    $to: String
    $search: String
    $limit: Int
    $offset: Int
  ) {
    getPropertyAgents(
      from: $from
      to: $to
      search: $search
      limit: $limit
      offset: $offset
    ) {
      status
      message
      data {
        count
        propertyAgents {
          id
          firstName
          lastName
          email
          code
          status
          createdAt
          totalRealtors
        }
      }
    }
  }
`;

export const GET_USER_REFEREES = gql`
  query GetUserReferees(
    $referralDetailsId: String!
    $limit: Int
    $offset: Int
    $filters: DateFilter
    $search: String
  ) {
    getUserReferees(
      referralDetailsId: $referralDetailsId
      limit: $limit
      offset: $offset
      filters: $filters
      search: $search
    ) {
      count
      referees {
        id
        referralDetailId
        userId
        earning
        status
        dateApproved
        createdAt
        updatedAt
        referred {
          firstName
          lastName
          email
          imageUrl
          status
          createdAt
          userRtDetail {
            enrollment_type
            onboardingStatus
          }
          primaryAddress {
            location
          }
        }
      }
    }
  }
`;

export const GET_REFERRAL_MINI_STATISTICS = gql`
  query GetReferralMiniStatistic($from: Date!, $to: Date!) {
    getReferralMiniStatistic(from: $from, to: $to) {
      totalReferrals
      totalReferralPercentageChange
      successfulConversions
      totalSuccessfulReferralPercentageChange
      totalAmountWithdrawnPercentageChange
      totalAmountWithdrawn
    }
  }
`;

export const GET_ADMIN_AGENT_STATISTIC = gql`
  query GetAdminAgentStatistic {
    getAdminAgentStatistic {
      status
      message
      data {
        codes
        totalRealtors
        totalCodesPercentageChange
        totalRealtorsPercentageChange
      }
    }
  }
`;

export const GET_KAABO_PARTNERS = gql`
  query GetKaaboPartners(
    $from: String
    $to: String
    $search: String
    $limit: Int
    $offset: Int
  ) {
    getKaaboPartners(
      from: $from
      to: $to
      search: $search
      limit: $limit
      offset: $offset
    ) {
      status
      message
      data {
        count
        kaaboPartners {
          id
          partnerName
          email
          code
          status
          createdAt
          totalReferredUsers
        }
      }
    }
  }
`;

export const GET_ADMIN_PARTNER_STATISTICS = gql`
  query GetAdminPartnerStatistics {
    getAdminPartnerStatistic {
      status
      message
      data {
        partners
        totalReferredUsers
        totalPartnersPercentageChange
        totalReferredUsersPercentageChange
      }
    }
  }
`;

export const GET_REFERRAL_DONUT_ANALYTICS = gql`
  query GetReferralDonutAnalytics($from: Date!, $to: Date!) {
    getReferralDonutAnalytics(from: $from, to: $to) {
      totalReferral
      totalAmountPaid
      totalAmountWithdrawn
      totalAmountWithdrawnPercentageChange
    }
  }
`;

export const GET_REFERRAL_BAR_ANALYTICS = gql`
  query Query($filter: BarFilterEnum) {
    getReferralsBarAnalytics(filter: $filter)
  }
`;

export const GET_REFERRAL_DETAILES_BY_USER_ID = gql`
  query GetReferralDetailsByUserId($userId: String!) {
    getReferralDetailsByUserId(userId: $userId) {
      id
      userId
      referralCode
      earnings
      totalReferred
      completedReferrals
      createdAt
      updatedAt
      user {
        firstName
        lastName
        createdAt
        imageUrl
      }
    }
  }
`;

export const GET_USERS_COMMENT = gql`
  query CComments(
    $id: ID!
    $offset: Int
    $limit: Int
    $search: String
    $filters: FiltersType
  ) {
    getUserComments(
      id: $id
      offset: $offset
      limit: $limit
      search: $search
      filters: $filters
    ) {
      count
      data {
        admin {
          firstName
          lastName
          email
        }
        comment
        action
        id
        adminId
        createdAt
      }
    }
  }
`;

export const GET_ALL_ADMIN_LOANS = gql`
  query getAllCaLoans(
    $offset: Int
    $limit: Int
    $filters: FiltersType
    $statusFilter: String
    $search: String
    $userId: String
  ) {
    getAllCaLoans(
      offset: $offset
      limit: $limit
      filters: $filters
      statusFilter: $statusFilter
      search: $search
      userId: $userId
    ) {
      count
      loans {
        id
        tenor
        loanAmount
        downPayment
        repaymentDuration
        loanStatusId
        moratoriumDuration
        hasFirstAndLastMonthPayment
        currency
        loanStartDate
        interest
        meta
        loanStatus {
          name
        }
        user {
          email
          firstName
          lastName
          imageUrl
        }
        property {
          propertyAddress
          landlord {
            firstName
            lastName
            email
            phone
          }
        }
        createdAt
      }
    }
  }
`;

export const GET_ALL_CUSTOMERS = gql`
  query usersKaabo(
    $offset: Int
    $limit: Int
    $filters: FiltersType
    $search: String
    $statusFilter: String
    $product: String
  ) {
    usersKaabo(
      limit: $limit
      offset: $offset
      filters: $filters
      statusFilter: $statusFilter
      search: $search
      product: $product
    ) {
      users {
        id
        firstName
        lastName
        email
        payfiId
        phone
        createdAt
        status
        bvn
        imageUrl
        payfiProduct {
          name
        }
        priorityUser {
          userId
        }
        lastLoginAt
        onboardingRoute
        onBoardingStage
        stage
        approvedAt
        userRtDetail {
          product
          onboardingStatus
          meta
        }
      }
      count
    }
  }
`;

export const GET_ALL_STAFF = gql`
  query getStaff(
    $limit: Int
    $offset: Int
    $search: String
    $statusFilter: String
    $roleId: String
  ) {
    getStaffs(
      limit: $limit
      offset: $offset
      search: $search
      statusFilter: $statusFilter
      roleId: $roleId
    ) {
      status
      message
      data {
        count
        rows {
          id
          firstName
          lastName
          email
          phone
          status
          department
          role {
            display_name
            name
            id
          }
        }
      }
    }
  }
`;

export const GET_ALL_ROLES = gql`
  query GetAllRoles {
    getAllRoles {
      message
      roles {
        created_by
        display_name
        id
        is_active
        name
        userCount
        activeUserCount
        inactiveUserCount
        permissions {
          created_by
          group
          id
          name
        }
      }
    }
  }
`;

export const GET_ALL_PERMISSIONS = gql`
  query Permissions($roleId: ID, $type: String, $platform: String) {
    getAllPermissions(roleId: $roleId, type: $type, platform: $platform) {
      permissions {
        created_by
        group
        id
        name
        hasPermission
      }
      status
    }
  }
`;

export const GET_ADMIN_CUSTOMER_TRANSACTIONS = gql`
  query getAllTransactionsAdminCa(
    $search: String
    $limit: Int
    $offset: Int
    $filters: FiltersType
    $statusFilter: String
    $userId: String
  ) {
    getAllTransactionsAdminCa(
      userId: $userId
      offset: $offset
      limit: $limit
      search: $search
      filters: $filters
      statusFilter: $statusFilter
    ) {
      count
      transactions {
        id
        txRef
        description
        narration
        message
        paymentMethod
        amount
        currency
        fees
        createdAt
        status
        user {
          firstName
          lastName
          email
        }
      }
    }
  }
`;

export const GET_ADMIN_CUSTOMER_DETAILS_LOAN = gql`
  query getAllCaLoans(
    $search: String
    $limit: Int
    $offset: Int
    $filters: FiltersType
    $statusFilter: String
    $userId: String
  ) {
    getAllCaLoans(
      userId: $userId
      offset: $offset
      limit: $limit
      search: $search
      filters: $filters
      statusFilter: $statusFilter
    ) {
      count
      loans {
        id
        amount
        userId
        tenor
        loanChannel
        nextRepaymentDate
        dueDate
        createdAt
        payfiId
        outstandingAmount
        user {
          firstName
          lastName
        }
        order {
          amount
        }
        loanStatus {
          name
        }
        merchant {
          name
        }
      }
    }
  }
`;

export const GET_ADMIN_CUSTOMER_DETAILS_REPAYMENT = gql`
  query getRepaymentsCa(
    $search: String
    $limit: Int
    $offset: Int
    $filters: FiltersType
    $statusFilter: String
    $userId: String
  ) {
    getRepaymentsCa(
      userId: $userId
      offset: $offset
      limit: $limit
      search: $search
      filters: $filters
      statusFilter: $statusFilter
    ) {
      count
      repayments {
        id
        isFullyPaid
        dueDate
        amountDue
        payDate
        loanId
        transactions {
          paymentMethod
        }
        loan {
          userId
          id
          loanAmount
          tenor
          user {
            firstName
            lastName
            email
            phone
            imageUrl
            id
          }
          property {
            propertyAddress
            landlord {
              firstName
              lastName
              email
              phone
            }
          }
          loanStatus {
            name
          }
        }
        transactions {
          id
          paymentMethod
          status
          createdAt
        }
      }
    }
  }
`;

export const GET_ADMIN_ALL_REPAYMENT = gql`
  query getRepaymentsCa(
    $search: String
    $limit: Int
    $offset: Int
    $filters: FiltersType
    $statusFilter: String
    $userId: String
  ) {
    getRepaymentsCa(
      userId: $userId
      offset: $offset
      limit: $limit
      search: $search
      filters: $filters
      statusFilter: $statusFilter
    ) {
      count
      repayments {
        id
        isFullyPaid
        dueDate
        amountDue
        payDate
        loanId
        transactions {
          paymentMethod
        }
        loan {
          userId
          id
          loanAmount
          tenor
          property {
            propertyAddress
            landlord {
              firstName
              lastName
              email
              phone
            }
          }
          loanStatus {
            name
          }
          user {
            firstName
            lastName
            email
            phone
            imageUrl
          }
        }
        transactions {
          id
          paymentMethod
          status
          createdAt
        }
      }
    }
  }
`;

export const GET_ADMIN_TRANSACTION_BY_ID = gql`
  query getTransactionByIdCa($id: ID!) {
    getTransactionByIdCa(id: $id) {
      id
      status
      narration
      description
      amount
      createdAt
      txRef
      paymentMethod
      fees
      message
      user {
        firstName
        lastName
        email
        phone
        id
        userRtDetail {
          onboardingStatus
          enrollment_type_other
          enrollment_type
          enrolled_as_student
          campus
        }
        primaryAddress {
          zipCode
          state
          city
        }
      }
      loan {
        id
        loanSchedules {
          dueDate
          amountDue
        }
        property {
          propertyAddress
          rentAmount
          leaseAgreementDoc
          meta
          landlord {
            firstName
            lastName
            email
            phone
            landlordType
            companyName
            properties {
              leaseAgreementDoc
            }
          }
        }
      }
      rentGuarantee {
        property {
          rentAmount
          propertyAddress
          leaseAgreementDoc
          meta
          landlord {
            firstName
            lastName
            landlordType
            companyName
            email
            properties {
              leaseAgreementDoc
            }
            phone
          }
        }
      }
      rentPayment {
        property {
          rentAmount
          propertyAddress
          postalCode
          leaseAgreementDoc
          city
          meta
          landlord {
            lastName
            firstName
            phone
            landlordType
            email
            companyName
          }
        }
        rentAmount
      }
    }
  }
`;

export const GET_ADMIN_LOAN_BY_ID = gql`
  query getLoanCa($id: String!) {
    getLoanCa(id: $id) {
      id
      tenor
      loanAmount
      downPayment
      repaymentDuration
      loanStatusId
      moratoriumDuration
      hasFirstAndLastMonthPayment
      currency
      loanStartDate
      interest
      meta
      property {
        rentAmount
        propertyAddress
        leaseStartDate
        hasleaseAgreementDoc
        leaseAgreementDoc
        currency
        meta
        landlord {
          firstName
          lastName
          email
          phone
        }
      }
      createdAt
      approvedByAdmin {
        id
        firstName
        lastName
        email
        imageUrl
        phone
        status
        department
      }
      user {
        firstName
        lastName
        email
        phone
        status
        imageUrl
        promise
        id
        onboardingChannel
        userRtDetail {
          enrolled_as_student
          enrollment_type
          enrollment_type_other
          onboardingStatus
        }
        activeCard {
          last4digits
        }
      }
      loanStatus {
        name
      }
      loanSchedules {
        id
        amountDue
        dueDate
        isFullyPaid
        createdAt
      }
    }
  }
`;

export const GET_ADMIN_REPAYMENT_BY_ID = gql`
  query getRepaymentByIdCa($id: String!) {
    getRepaymentByIdCa(id: $id) {
      id
      isFullyPaid
      dueDate
      amountDue
      transactions {
        id
        status
        amount
      }
      loan {
        id
        tenor
        loanAmount
        downPayment
        repaymentDuration
        loanStatusId
        moratoriumDuration
        hasFirstAndLastMonthPayment
        currency
        loanStartDate
        interest
        createdAt
        meta
        property {
          rentAmount
          propertyAddress
          leaseStartDate
          hasleaseAgreementDoc
          leaseAgreementDoc
          currency
          meta
          landlord {
            firstName
            lastName
            email
            phone
          }
        }
        user {
          firstName
          lastName
          email
          phone
          status
          id
          userRtDetail {
            enrolled_as_student
            enrollment_type
            enrollment_type_other
            onboardingStatus
          }
        }
        loanStatus {
          name
        }
        loanSchedules {
          id
          amountDue
          dueDate
          isFullyPaid
        }
      }
    }
  }
`;

export const GET_ADMIN_CUSTOMER_BY_ID_V3 = gql`
  query getUserByIdAdmin($id: String!) {
    getUserByIdAdmin(id: $id) {
      id
      firstName
      email
      lastName
      otherName
      bvn
      maritalStatus
      phone
      gender
      createdAt
      imageUrl
      dob
      status
      eligibilityStatus
      promise
      isDeleted
      approvedAt
      isDeclined
      isBVNVerified
      onBoardingStage
      defaultProvider
      offer
      onboardingChannel
      activeCardId
      phone2
      hasProfileUpdateRequest
      payfiProduct {
        id
        name
        disbursementPartnerId
        status
      }
      primaryAddress {
        city
        state
        street
        lga
        houseNo
        location
        verificationStatus
        zipCode
        country
      }
      documents {
        id
        documentType
        issueDate
        status
        frontImage
        backImage
        expireDate
        documentId
        reason
        uri
        docKey
        file_ext
        updatedAt
        provider
        approveBy
        approvedByAdmin {
          firstName
          lastName
          email
        }
        meta {
          contentType
          file_size
        }
      }
      userRtDetail {
        id
        userId
        studentEmail
        nationality
        meta
        institution_name
        institution_city
        campus
        degree
        flight_question
        flight_answer
        selfie
        isPGWPEligible
        enrolled_as_student
        enrollment_type
        enrollment_type_other
        institution_province
        onboardingStatus
        monthly_income
        employment_status
      }
    }
  }
`;

export const ADMIN_VIEW_DOCUMENT = gql`
  query viewDocumentUsingID($id: ID!) {
    viewDocumentUsingID(id: $id) {
      status
      message
      url
    }
  }
`;

export const REPAYMENT_CONFIG = gql`
  query getRepaymentConfig {
    getRepaymentConfig {
      status
      message
      data {
        defaultPercentage
        gracePeriod
      }
    }
  }
`;

export const GET_INSTITUTION_DETAILS = gql`
  query getInstutionDetails {
    getInstutionDetails {
      status
      message
      data
    }
  }
`;

export const VERIFY_URL_NAME = gql`
  query checkIfPaymentLinkNameExist($name: String!) {
    checkIfPaymentLinkNameExist(name: $name)
  }
`;

export const GET_ALL_ADMIN_GUARANTEES = gql`
  query getAllRentGuarantees(
    $offset: Int
    $limit: Int
    $filters: FiltersType
    $statusFilter: String
    $guaranteeType: String
    $search: String
    $userId: String
  ) {
    getAllRentGuarantees(
      offset: $offset
      limit: $limit
      filters: $filters
      statusFilter: $statusFilter
      guaranteeType: $guaranteeType
      search: $search
      userId: $userId
    ) {
      count
      rentGuarantees {
        id
        amount
        currency
        annualIncome
        guaranteeApprovedAt
        guaranteeStartDate
        guaranteeEndDate
        guaranteeType
        monthlyRent
        meta
        tenor
        status
        user {
          email
          firstName
          lastName
          imageUrl
        }
        property {
          propertyAddress
          landlord {
            firstName
            lastName
            email
            phone
            companyName
            website
          }
        }
        createdAt
      }
    }
  }
`;

export const GET_ADMIN_GUARANTEE_BY_ID = gql`
  query getRentGuarantee($id: String!) {
    getRentGuarantee(id: $id) {
      id
      amount
      currency
      annualIncome
      guaranteeStartDate
      guaranteeEndDate
      guaranteeType
      meta
      status
      tenor
      monthlyRent
      property {
        rentAmount
        propertyAddress
        leaseStartDate
        hasleaseAgreementDoc
        leaseAgreementDoc
        currency
        meta
        landlord {
          firstName
          lastName
          email
          phone
          companyName
          website
        }
      }
      createdAt
      approvedByAdmin {
        id
        firstName
        lastName
        email
        imageUrl
        phone
        status
        department
      }
      user {
        firstName
        lastName
        email
        phone
        status
        imageUrl
        promise
        id
        onboardingChannel
        activeCard {
          last4digits
        }
        userRtDetail {
          enrolled_as_student
          enrollment_type
          enrollment_type_other
          onboardingStatus
        }
      }
    }
  }
`;

export const GET_RENT_PAYMENT_ADMIN_DASHBOARD = gql`
  query GetRentPaymentAdminDashboard(
    $limit: Int
    $offset: Int
    $search: String
    $statusFilter: String
    $filters: FiltersType
  ) {
    getRentPaymentAdminDashboard(
      limit: $limit
      offset: $offset
      search: $search
      statusFilter: $statusFilter
      filters: $filters
    ) {
      data {
        rentPayments {
          count
          rows {
            id
            rentAmount
            status
            settlementStatus
            createdAt
            actionDate
            meta
            equifaxSubmitted
            user {
              firstName
              lastName
              email
              phone
              imageUrl
              userRtDetail {
                creditBuilderStatus
              }
            }
          }
        }
        totalRentPaid
        totalAwaitingSettlement
        totalRentRefunded
        totalRentSettled
      }
      status
      message
    }
  }
`;

export const GET_ADMIN_RENT_PAYMENT_SINGLE = gql`
  query GetAdminRentPaymentSingle($rentPaymentId: String!) {
    getAdminRentPaymentSingle(rentPaymentId: $rentPaymentId) {
      status
      message
      data {
        id
        rentAmount
        settlementStatus
        user {
          firstName
          lastName
          email
          phone
          userRtDetail {
            creditBuilderStatus
          }
        }
        actionTakenBy {
          firstName
          lastName
          email
        }
        actionDate
        meta
        status
        equifaxSubmitted
        equifaxGenerated
        equifaxS3Url
        equifaxSubmittedBy
        equifaxSubmittedAt
        property {
          propertyAddress
          leaseAgreementDoc
          landlord_e_transfer_email
          unitNumber
          meta
          landlord {
            firstName
            companyName
            lastName
            landlordType
            email
            phone
          }
        }
        realtorPropertyId
        propertyId
        tenant {
          landlord {
            firstName
            lastName
            email
            country
            communicationAddress
            city
            noOfUnits
            phone
            id
          }
          property {
            id
            rentalAddress
            realtorId
          }
        }
      }
    }
  }
`;

export const GET_ADMIN_SINGLE_BILLS_PAYMENT = gql`
  query GetOneBillPaymentsAdminCa($billPaymentId: String!) {
    getOneBillPaymentsAdminCa(billPaymentId: $billPaymentId) {
      id
      userId
      biller
      billerCode
      accountId
      currency
      amount
      fee
      status
      narration
      datePaid
      meta
      createdAt
      updatedAt
      user {
        firstName
        lastName
        email
      }
    }
  }
`;

export const GET_SINGLE_STAFF = gql`
  query GetSingleStaff($adminId: String!) {
    getSingleStaff(adminId: $adminId) {
      status
      message
      data {
        status
        phone
        lastName
        firstName
        email
        department
        createdAt
        lastLoggedInAt
        role {
          name
          id
        }
        id
      }
    }
  }
`;
export const GET_USER_WALLET = gql`
  query GetUserWallet($userId: String!) {
    getUserWallet(userId: $userId) {
      balance
    }
  }
`;

export const GET_USER_CA_WALLET_TRANSACTIONS = gql`
  query GetUserCaWalletTransactions(
    $userId: String!
    $limit: Int
    $offset: Int
    $filter: UserCaTransactionFilter
  ) {
    getUserCaWalletTransactions(
      userId: $userId
      limit: $limit
      offset: $offset
      filter: $filter
    ) {
      data {
        count
        transactions {
          amount
          createdAt
          currency
          description
          fees
          id
          txRef
          status
          narration
          loanId
          loanScheduleId
        }
      }
      message
      status
    }
  }
`;

export const GET_ADMIN_APARTMENTS = gql`
  query GetAdminApartmentDetailPaginated(
    $limit: Int
    $offset: Int
    $search: String
    $statusFilter: String
  ) {
    getAdminApartmentDetailPaginated(
      limit: $limit
      offset: $offset
      search: $search
      statusFilter: $statusFilter
    ) {
      message
      status
      data {
        count
        rows {
          id
          userId
          apartmentType
          monthlyBudget
          monthlyIncome
          city
          province
          additionalInformation
          status
          lastActionedBy
          lastActionedAt
          refundedAt
          paymentAmount
          meta
          transaction {
            id
            amount
            status
            txRef
          }
          user {
            email
            firstName
            imageUrl
            lastName
            phone
          }
        }
      }
    }
  }
`;

export const GET_ADMIN_APARTMENT_DETAILS = gql`
  query GetAdminApartmentDetailSingle(
    $getAdminApartmentDetailSingleId: String!
  ) {
    getAdminApartmentDetailSingle(id: $getAdminApartmentDetailSingleId) {
      status
      message
      data {
        transaction {
          amount
          createdAt
          currency
          id
          txRef
        }
        additionalInformation
        apartmentType
        city
        id
        lastActionedAt
        lastActionedBy
        meta
        monthlyBudget
        monthlyIncome
        paymentAmount
        province
        refundedAt
        status
        user {
          email
          firstName
          gender
          id
          lastName
          imageUrl
          userRtDetail {
            onboardingStatus
            enrollment_type
            enrollment_type_other
          }
        }
      }
    }
  }
`;

export const GET_ADMIN_PRODUCT_DISTRIBUTIONS = gql`
  query GetAdminProductDistributions {
    getAdminProductDistributions {
      status
      message
      data {
        apartment_search
        pre_rent_guarantee
        rent_guarantee
        rent_payment
        totalUsersCount
      }
    }
  }
`;

export const GET_PRODUCT_Trends = gql`
  query GetAdminProductTrends($year: Int) {
    getAdminProductTrends(year: $year) {
      status
      message
      data {
        apartmentSearch {
          count
          month
          monthIndex
        }
        preRentGuarantee {
          count
          month
          monthIndex
        }
        rentGuarantee {
          count
          month
          monthIndex
        }
        rentPayment {
          count
          month
          monthIndex
        }
      }
    }
  }
`;

export const GET_EQUIFAX_REPORTS_ADMIN_DASHBOARD = gql`
  query getAllEquifaxReports(
    $limit: Int
    $offset: Int
    $search: String
    $statusFilter: String
  ) {
    getAllEquifaxReports(
      limit: $limit
      offset: $offset
      search: $search
      statusFilter: $statusFilter
    ) {
      data {
        count
        rows {
          id
          fileName
          equifaxS3Url
          equifaxSubmittedBy
          equifaxSubmittedAt
          equifaxSubmitted
          equifaxSubmittedByAdmin {
            firstName
            lastName
            email
          }
          monthGeneratedFor
          meta
          createdAt
        }
      }
      status
      message
    }
  }
`;

export const DOWNLOAD_EQUIFAX_FILE = gql`
  query getEquifaxSignedMetro2File($id: ID!) {
    getEquifaxSignedMetro2File(id: $id) {
      status
      message
      url
    }
  }
`;

export const GET_REALTOR_DETAILS_BY_AGENT_ID = gql`
  query GetRealtorsByAgentId(
    $agentId: String!
    $from: String
    $to: String
    $search: String
    $limit: Int
    $offset: Int
  ) {
    getRealtorsByAgentId(
      agentId: $agentId
      from: $from
      to: $to
      search: $search
      limit: $limit
      offset: $offset
    ) {
      status
      message
      data {
        realtors {
          id
          firstName
          lastName
          email
          selfie
          createdAt
          status
          numberOfProperties
          numberOfTenants
        }
        count
      }
    }
  }
`;

export const GET_REALTOR_DETAILS = gql`
  query GetPropertyAgentDetails($agentId: String!) {
    getPropertyAgentDetails(agentId: $agentId) {
      data {
        id
        firstName
        lastName
        createdAt
        code
        status
        totalReferrals
      }
      message
      status
    }
  }
`;

export const GET_ADMIN_PARTNER_DETAILS = gql`
  query GetAdminPartnerDetails($partnerId: String!) {
    getAdminPartnerDetails(partnerId: $partnerId) {
      data {
        id
        partnerName
        email
        code
        partnerId
        createdAt
        status
        totalReferrals
      }
      message
      status
    }
  }
`;

export const GET_PARTNER_REFERRED_USERS_BY_PARTNER = gql`
  query GetPartnerReferredUsersByPartnerId(
    $partnerId: String!
    $from: String
    $to: String
    $search: String
    $limit: Int
    $offset: Int
  ) {
    getPartnerReferredUsersByPartnerId(
      partnerId: $partnerId
      from: $from
      to: $to
      search: $search
      limit: $limit
      offset: $offset
    ) {
      status
      message
      data {
        users {
          id
          firstName
          lastName
          email
          phone
          createdAt
          updatedAt
          signup_referral_code_kaabo
          userRtDetail {
            institution_name
            company_name
            enrollment_type
            institutionVerifyStatus
          }
          tenants {
            id
            rentAmount
            leaseStartDate
            leaseEndDate
            status
          }
          rentPayments {
            id
            rentAmount
            status
            createdAt
          }
        }
        count
      }
    }
  }
`;

export const GET_ALL_KAABO_COUPONS = gql`
  query GetAllKaaboCoupons(
    $limit: Int
    $offset: Int
    $status: String
    $search: String
    $partnerId: String
  ) {
    getAllCoupons(
      limit: $limit
      offset: $offset
      status: $status
      search: $search
      partnerId: $partnerId
    ) {
      status
      message
      data {
        count
        coupons {
          id
          couponCode
          couponAlias
          partnerId
          modifiedBy
          expiryDate
          maxUses
          currentUses
          discountType
          discountValue
          status
          createdAt
          updatedAt
          partner {
            id
            partnerName
            status
          }
        }
      }
    }
  }
`;
